import { render, staticRenderFns } from "./LiveUser.vue?vue&type=template&id=649e5fbf&scoped=true"
import script from "./LiveUser.vue?vue&type=script&lang=js"
export * from "./LiveUser.vue?vue&type=script&lang=js"
import style0 from "./LiveUser.vue?vue&type=style&index=0&id=649e5fbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649e5fbf",
  null
  
)

export default component.exports